import { ControlType, unbindParameterName } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { ProcessTemplatesParameterSelector } from "~/areas/platformHub/processEditor/ProcessTemplatesParameterSelector";
import { ExpandableFormSection, Summary, Note } from "~/components/form";
interface TenantsParameterExpanderProps {
    tenantTagsVariable: string | null;
    onTenantTagsVariableChange(tenantTagsVariable: string): void;
}
export function TenantsParameterExpander({ tenantTagsVariable, onTenantTagsVariableChange }: TenantsParameterExpanderProps) {
    return (<ExpandableFormSection errorKey="tenantTags" title={"Tenants"} accessibleName="Tenants" help="Choose which tenants this step applies to." summary={tenantTagsVariable
            ? Summary.summary(<span>
                              This step will only run for tenants specified by the parameter <strong>{unbindParameterName(tenantTagsVariable)}</strong>
                          </span>)
            : Summary.default("This step will run when untenanted or for all tenants")}>
            <ProcessTemplatesParameterSelector selectedParameter={tenantTagsVariable} onParameterChange={onTenantTagsVariableChange} controlType={ControlType.TenantTags} allowClear={true}/>
            <Note>This step will only run for tenants matching this filter. Clear the filter to make the step run for all tenants. Note: if you define a filter, this step will be skipped when performing un-tenanted deployments.</Note>
        </ExpandableFormSection>);
}
